<template>
  <div class="home">
    <!-- Banner -->
    <div class="banner" :style="{backgroundImage: 'url('+BannerImg+')'}">
      <div class="info-box">
        <div class="portrait">
          <a href="/me"><img :src="protraitImgUrl" alt=""></a>
        </div>
        <div class="proverb-box">
          <div class="proverb">{{proberb}}</div>
        </div>
      </div>
    </div>
    <!-- 主内容 -->
    <main class="main">
      <!-- 消息通知 -->
      <transition name="el-fade-in-linear">
        <div v-if="alertTimeout"  style="margin-bottom:30px;">
          <el-alert title="为保证你的网站使用体验, 请尽量使用电脑访问哦." type="warning" close-text="我知道了" center closable />
        </div>
      </transition>
      <el-row>
        <el-col :lg="16">
          <BlogList :loading="isLoading" :blogs="blogs" :pagingParams="pagingParams" @currentPageChange="currentPageChange" />
        </el-col>
        <el-col :lg="7">
          <Aside />
        </el-col>
      </el-row>
    </main>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive, toRefs } from 'vue'
import txImg from '@/assets/tx.png'
import BlogList from '@/components/BlogList.vue'
import Aside from '@/components/Aside.vue'
import { useDelay, useLog, usePostRequest } from '@/hooks'
import { AssertGoodResponse } from '@/util/GlobalUtil'
import BannerImg from '@/assets/engine.jpg'

export default defineComponent({
  name: 'Home',
  components: {
    BlogList,
    Aside,
  },
  setup() {
    // eslint-disable-next-line
    const l = useLog()
    const state = reactive({
      bannerBgImgUrl:
        'https://cdn.jsdelivr.net/gh/dateolive/Hi-Dream-BlogReSource@main/img/backgroundimg.jpg',
      protraitImgUrl: txImg,
      proberb: '以代码为镜，可通逻辑；以人本为镜，可明得失。',
      blogs: [],
      pagingParams: {
        pageSize: 5,
        currentPage: 1,
        total: 100,
      },
      isLoading: true,
      alertTimeout: useDelay(5000).isLoading,
    })

    const getBlogInfo = () => {
      state.isLoading = true
      // 初始化博客,传入BlogList组件
      usePostRequest('/api/blog', state.pagingParams)
        .then((res) => {
          AssertGoodResponse(res)
          state.blogs = res.data.data.collection
          state.pagingParams.pageSize = res.data.data.pageSize
          state.pagingParams.currentPage = res.data.data.currentPage
          state.pagingParams.total = res.data.data.total
          // l(`第${state.pagingParams.currentPage}页的数据:`, state.blogs)
        })
        .finally(() => {
          state.isLoading = false
        })
    }

    const currentPageChange = (newCurrentPage: number) => {
      state.pagingParams.currentPage = newCurrentPage
      getBlogInfo()
    }

    // BeforeCreate
    getBlogInfo()

    return {
      ...toRefs(state),
      currentPageChange,
      BannerImg
    }
  },
})
</script>

<style lang="scss" scoped>
.home {
  .banner {
    margin: 0 auto;
    text-align: center;
    width: 100%;
    height: 480px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    position: relative;
    box-shadow: 0 19px 28px 0 rgba(0, 0, 0, 0.18);
    border-radius: 25px;

    @media screen and (max-width: 1450px) {
      width: 1024px;
    }
    @media screen and (max-width: 992px) {
      width: 800px;
    }
    @media screen and (max-width: 760px) {
      width: 650px;
    }

    .info-box {
      color: white;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);

      .portrait {
        img {
          width: 100px;
          height: 100px;
          border-radius: 50%;
          border: 2.5px solid $theme-color;
          transition: transform 0.4s;
          &:hover {
            transform: translateY(-10px);
          }
        }
      }

      .proverb-box {
        // width: 200px;
        color: #eaeadf;
        background: rgba(0, 0, 0, 0.6);
        padding: 20px 20px;
        margin: 30px auto 0 auto;
        letter-spacing: 1px;
        line-height: 30px;
        border-radius: 5px;
        cursor: not-allowed;
        user-select: none;

        .proverb {
          font-size: 0.8rem;
        }
      }
    }
  }

  .main {
    // border: 1px solid blue;
    margin-top: 60px;
  }
}
</style>